export default {
  backgroundColour: 'brandTwo80',
  includeInverseLogo: false,
  linkColour: 'utilityWhite',
  linkHoverDecoration: 'underline',
  linkDividerColor: 'utilityWhite',
  smallTextColor: 'utilityWhite',
  seperateLinkBar: true,
};
